export default function ProfileTabs({ activeTab, setActiveTab }) {
  const tabs = [
    { key: "info", label: "Profile" },
    { key: "edit", label: "Edit Profile" },
    { key: "wallet", label: "Wallet" },
    { key: "referral", label: "Referral" },
    { key: "password", label: "Password" },
  ];

  return (
    <div className="profile-tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.key}
          className={`profile-tab-btn ${
            activeTab === tab.key ? "active" : ""
          }`}
          onClick={() => setActiveTab(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
